"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightGray = exports.darkGray = exports.gray = exports.veryLightGray = exports.lightBlue = exports.lightGreen = exports.lightRed = exports.green = exports.teal = exports.red = exports.orange = exports.black = exports.defaultBlue = void 0;
exports.defaultBlue = '#4E79A7';
exports.black = 'black';
exports.orange = '#F28E2B';
exports.red = '#FF0000';
exports.teal = '#76B7B2';
exports.green = '#009900';
exports.lightRed = '#FCD8D7';
exports.lightGreen = '#D1EDCB';
exports.lightBlue = '#46a0dc';
exports.veryLightGray = '#F2F2F2';
exports.gray = '#666666';
exports.darkGray = '#33333';
exports.lightGray = '#C1C1C1'; // Not in UX, replace later?
//# sourceMappingURL=colors.js.map